module.exports = __webpack_public_path__ + "9dd4348ea09f804b8b9437096749cc3a.jpg";